export function genCheckContentsFit(contents: HTMLElement, height: number): () => boolean {
	return () => contents.clientHeight <= height;
}
